@if(authHistoryFormattedData.length > 0){
<p-table [value]="authHistoryFormattedData" dataKey="createdDateWithTime" [rowExpandMode]="'single'"
  class="audit-table">
  <!-- MAIN TABLE HEADER -->
  <ng-template pTemplate="header">
    <tr>
      <th><b>Created By</b></th>
      <th><b>Created Date</b></th>
      <th><b>Modified By</b></th>
      <th><b>Modified Date</b></th>
      <th><b>Modified Fields</b></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row>
    <tr style="font-size: 11px;">
      <td>{{ row.createdBy }}</td>
      <td>{{ row.createdDate | date:'yyyy-MM-dd' }}</td>
      <td>{{ row.modifiedBy }}</td>
      <td>{{ row.modifiedDate | date:'yyyy-MM-dd' }}</td>
      <td>
        <ng-container *ngFor="let field of row.modified_fields;">
          <div>
            <span style="display: inline-block; min-width: 150px;"><b>{{ field.col_name }}</b></span>
            <span class="text-danger" style="display: inline-block; min-width: 80px;">{{ field.prev_value || '—' }}</span>
            <span style="display: inline-block; min-width: 30px;">&rarr;</span>
            <span class="text-success" style="display: inline-block; min-width: 80px;">{{ field.curr_value || '—' }}</span>
          </div>
        </ng-container>
      </td>
    </tr>
  </ng-template>
</p-table>
}
@else {
No Data Available
}